import { useMemo } from "react";
import { ID } from "../../types";

type LocalRow = {
    id: ID,
    dateVisited: string,
}

export function useLocalHistory(localStorageKey: string, id?: ID): string[] {
    return useMemo(() => {
        const data = getLocalData("history-" + localStorageKey);

        if (id) {
            const index = data.findIndex(row => row.id === id);
            const dateVisited = new Date().toISOString();
            if (index > -1) {
                data[index].dateVisited = dateVisited;
            } else {
                data.push({ id, dateVisited });
            }
            setLocalData("history-" + localStorageKey, data);
        }

        return data
            .sort((a, b) => b.dateVisited.localeCompare(a.dateVisited))
            .map(row => row.id);

    }, [localStorageKey, id]);
}

function getLocalData(localStorageKey: string): LocalRow[] {
    try {
        const dataString = localStorage.getItem(localStorageKey);
        const data = JSON.parse(dataString || "[]");
        const validData = checkLocalData(data);
        if (validData)
            return validData;
    } catch (e) { }

    return [];
}

function setLocalData(localStorageKey: string, data: LocalRow[]) {
    try {
        localStorage.setItem(localStorageKey, JSON.stringify(data));
    } catch (e) {
        // Server rendering
    }
}

function checkLocalData(d: any): null | LocalRow[] {
    if (
        Array.isArray(d)
        && d.every(row => row
            && typeof row.id === "string"
            && row.id.length > 4
            && typeof row.dateVisited === "string"
        )
    )
        return d;

    return null;
}